import React, { Component } from "react";
import styled from "styled-components";
import Equation from '../../components/Equation2';
import { Flex, Button } from "../../components";

const ModalWrapper = styled(Flex)`
  display: ${({ open }) => (open ? "display" : "none")};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.1);
`;

const ModalTextWrapper = styled(Flex)`
  width: 25vw;
  padding: 1em;
  border: 1px solid #aaa;
  border-radius: .5em;
  background: #fff;
  @media(max-width:767px){
    width: 95% !important;
    height: 65%;
    overflow: auto;
  }
`;

const Modal = ({ open, close, template, solution, math_type }) => (
  <ModalWrapper center open={open}>
    <ModalTextWrapper column>
      <p onClick={() => close()} style={{ fontSize: '14px', borderBottom: '1px solid #673AB7', color: '#673AB7', fontWeight: 'bold', margin: 'auto', marginRight: '0', marginBottom: '10px', marginTop: '10px' }} >close</p>
      {solution ? <div><strong style={{ fontWeight: '600', fontSize: '16px' }}>Solution</strong> -&nbsp;<Equation equation={solution} math_type={math_type}></Equation></div> : null}
      {template ?  <img src={template} alt="Solution Image" style={{maxWidth : "100%", maxHeight : "300px"}}/> : null}
      {/* <Flex justifyBetween>
        <Button onClick={handleModalToggle}>No</Button>
        <Button onClick={handleSubmit}>Yes</Button>
      </Flex> */}
      {/* {template ? <Equation equation={template} math_type={math_type}></Equation> : null} */}

      {/* <iframe style={{width: '100%', height: '100%'}} src='https://edwisely-cse.s3.ap-south-1.amazonaws.com/Mathematics-II/FLASHCARDS+HTMLs/Unit+5/Deck+1/Example+for+line+integral.html'></iframe> */}
    </ModalTextWrapper>
  </ModalWrapper>
);

export default Modal;
